import { i18n } from 'next-i18next';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';

const NAMESPACES = process.env.NEXT_PUBLIC_TRANSLATION_NAMESPACES?.split(',') || [];

export const useRefreshTranslations = () => {
  const router = useRouter();
  const [, setValue] = useState(0);
  const forceUpdate = () => setValue((value) => value + 1);

  const handleRouteChange = async (url, { shallow }) => {
    if (!shallow) {
      await i18n?.reloadResources();
      forceUpdate();
    }
  };

  useEffect(() => {
    i18n?.loadNamespaces(NAMESPACES);
    i18n?.reloadResources();
    router.events.on('routeChangeComplete', handleRouteChange);

    return () => {
      router.events.off('routeChangeComplete', handleRouteChange);
    };
  }, []);
};
